import { useAtomValue } from 'jotai'
import {
  Text,
  GreyGrey70,
  GreyGrey80,
  Primary14SemiBold,
  Primary13Regular,
  Flex
} from '@sequencehq/core-components'
import { Badge, CustomerLogo, SaveStatus } from '@sequencehq/core-components'
import {
  clientInvoiceSaveStatusAtom,
  humanReadableInvoiceNumberAtom,
  invoiceCustomerIdAtom,
  invoiceStatusAtom
} from 'Invoices/atoms/invoiceEditing.atom'
import { getLogoSrc, useFetchCustomerQuery } from 'Customer/index'
import { toInvoiceStatusBadgeProps } from '@sequencehq/utils'
import { useHumanReadableTotalAfterCreditGrants } from 'Invoices/hooks/useCreditGrantTotals'

type Props = {
  showStatusBadge?: boolean
}

export const HeaderTitle = ({ showStatusBadge = false }: Props) => {
  const isSaving = useAtomValue(clientInvoiceSaveStatusAtom)
  const totalAfterCredit = useHumanReadableTotalAfterCreditGrants()
  const invoiceNumber = useAtomValue(humanReadableInvoiceNumberAtom)
  const invoiceStatus = useAtomValue(invoiceStatusAtom)
  const customerId = useAtomValue(invoiceCustomerIdAtom)

  const { customerDetails: customer } = useFetchCustomerQuery(customerId ?? '')
  const logoSrc = customer ? getLogoSrc(customer) : undefined

  return (
    <Flex gap="8px" alignItems="center">
      {customer && <CustomerLogo src={logoSrc} size={16} />}

      <Text {...Primary14SemiBold} color={GreyGrey80}>
        {invoiceNumber}
      </Text>

      {customerId && (
        <Text
          {...Primary13Regular}
          color={GreyGrey70}
          data-testid="invoiceHeader.total"
        >
          {totalAfterCredit}
        </Text>
      )}

      {showStatusBadge && invoiceStatus && (
        <Badge
          {...toInvoiceStatusBadgeProps({
            status: invoiceStatus,
            size: 'sm'
          })}
        />
      )}

      <SaveStatus isSaving={isSaving} data-testId="invoice.save-status" />
    </Flex>
  )
}
